import PageHeader from "../components/PageHeader";
import ServicesSection from "../components/ServicesSection";
import Products from "../components/Products";

function ServicesPage() {
  return (
    <>
      <PageHeader
        crumb="Services"
        eyebrow="What We Offer"
        title="Our Services"
        lead="End-to-end technology services designed to help your business innovate, scale and succeed."
      />
      <ServicesSection />
      <Products />
    </>
  );
}

export default ServicesPage;
